import * as React from "react";

import "./paywall-modal.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {ModalService3}          from "@Common/ui-components/modal-service-3/modal-service-3";

export const PaywallModal = ({next: rootNext}) => cs(
    consumeContext('routerHistory'),
    ["modal", ({}, next) => ModalService3({
        xdQaName: "XD+ Plans Modal",
        urlParam: "learn",
        rootNext,
        next,
        xColor: "#ffffff",
        width: 552,
    })],
    ({routerHistory}) => (
        <div className="xd-plus-plans xd-plus-plans-xpp03">
            <div className="top" style={{backgroundImage: `url(${require("./images/background.svg")})`}}>
                <div className="yellow-square"/>
                <div className="top-child heading">
                    <div className="introducing" xd-qa-type="label" xd-qa-name="Introducing">Introducing</div>
                    <div className="logo" xd-qa-type="logo" xd-qa-name="XD Logo">
                        <img src={require("./images/xdplus-logo-white.svg")}/>
                    </div>
                </div>
                <div className="top-child sub-heading-1">
                    <div className="text" xd-qa-type="label" xd-qa-name="Subscribe to receive exclusive benefits and instant savings!">
                        Subscribe to receive<br/>exclusive benefits<br/>and instant savings!
                    </div>
                </div>
            </div>
            <div className="blue-square"/>
            <div className="middle">
                <div className="description">This template is only available to<br/><span className="bold">XD+ Yearly</span> subscribers</div>
                <div className="click-below">Click below to learn more!</div>
            </div>
            <div className="bottom">
                <button className="view-plans-button" onClick={() => routerHistory.push("/manage-subscriptions")}>View XD+ Plans</button>
            </div>
        </div>
    )
);